<script lang="ts">
	import type { IconName } from '$lib/components/icons/types';
	import type { ClassValue } from 'svelte/elements';
	import type { IconPosition } from './types';
	import RepeatIcons from '$lib/components/icons/RepeatIcons.svelte';

	interface Props {
		label?: string;
		icon?: IconName;
		iconPosition?: IconPosition;
		hideLabelOnMobile?: boolean;
		labelClasses?: ClassValue;
		iconClasses?: ClassValue;
		iconInsideClasses?: ClassValue;
		iconStyle?: 'currency' | 'distinction' | 'grade';
		amountOfRepeatedIcons?: number;
		ariaLabel?: string;
		tag?: string;
		iconTag?: string;
	}

	const {
		label,
		icon,
		iconPosition = 'left',
		hideLabelOnMobile = false,
		labelClasses,
		iconClasses,
		iconInsideClasses,
		amountOfRepeatedIcons,
		ariaLabel,
		iconStyle,
		tag = 'div',
		iconTag = 'div',
	}: Props = $props();

	const amount = $derived(amountOfRepeatedIcons ?? (icon ? 1 : 0));
</script>

{#if icon && iconPosition === 'left'}
	{@render repeatIcons()}
{/if}
{#if label}
	<span class:lt-md:sr-only={hideLabelOnMobile} class={labelClasses}>{label}</span>
{/if}
{#if icon && iconPosition === 'right'}
	{@render repeatIcons()}
{/if}

{#snippet repeatIcons()}
	<RepeatIcons {icon} {amount} {ariaLabel} class={iconClasses} {tag} {iconTag} style={iconStyle} iconClasses={iconInsideClasses} />
{/snippet}
